import { render } from "./CounterTable.vue?vue&type=template&id=74c6cce4&scoped=true"
import script from "./CounterTable.vue?vue&type=script&lang=js"
export * from "./CounterTable.vue?vue&type=script&lang=js"

import "./CounterTable.vue?vue&type=style&index=0&id=74c6cce4&scoped=true&lang=css"

import exportComponent from "/app/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74c6cce4"]])

export default __exports__